/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="26.5"
        height="24.8"
        viewBox="0 0 26.5 24.8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g
          fill="#4a4a4a"
          className="icon-fill">
          <path d="M6.3 0 0 11.6v13.2h11.4V12.2H6.3L9.9 0H6.3z"/>
          <path d="m21.4 0-6.3 11.6v13.2h11.4V12.2h-5.1L25 0h-3.6z"/>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'QuotationMarkDoubleSquareIcon';

export default Icon;
